import * as React from 'react';
import { Link } from 'react-router-dom';
import { IAccountDetails, IOrganization, IAlerts } from '../../services/account';
import { get as getDatabases, IDatabaseBase } from '../../services/database';
import { FormattedMessage } from 'react-intl';
import { IAvatar } from 'src/services/documents';
import {
    DATABASE_UPDATE_PATH,
    DATABASE_CREATE_PATH,
    SEARCH_PATH,
    PROFILE_EDIT,
    CONTACT_PATH,
    PARTNERS_PATH,
    PAGES_PATH,
    MESSAGES_PATH,
} from '../../constants';
import { isEmpty } from 'src/util';
import defaultAvatar from 'src/images/man-303792_640.png';

interface IState {
    databases: IDatabaseBase[] | null;
}

export default class Dashboard extends React.Component<
    {
        accountDetails: IAccountDetails | null;
        organization: IOrganization | null;
        avatar: IAvatar | null;
        alerts: IAlerts | null;
    },
    IState
> {
    state = {
        databases: null,
    };

    async componentDidMount() {
        await this.loadDatabases();
    }

    async loadDatabases() {
        const databases = await getDatabases(undefined, undefined, this.isClient() ? 'account' : 'partnered');
        if (databases.success && databases.databases)
            this.setState({ databases: databases.databases });
    }

    isClient = () => {
        return this.props.accountDetails != null ? this.props.accountDetails?.subscriptionLevel > 0 : true;
    }

    renderStatistics = () => {
        if (false) {
            return (
                <div className="dashboardAra">
                    <div className="infoDetailsallpage">
                        <div className="subtitleArea">
                            <h4>
                                <FormattedMessage id="dash.stats.hdr" defaultMessage="Statistics" />
                            </h4>
                            <a href="#">
                                <FormattedMessage
                                    id="dash.stats.lifetime"
                                    defaultMessage="Lifetime Statistics"
                                />{' '}
                                <i className="fas fa-angle-down" />
                            </a>
                        </div>
                        <div className="dbStatistics">
                            <ul>
                                <li key="dash-stats-partners">
                                    <h4>
                                        <FormattedMessage
                                            id="dash.stats.partners"
                                            defaultMessage="Total Partners"
                                        />
                                        15
                                    </h4>
                                </li>

                                <li key="dash-stats-pages">
                                    <h4>
                                        <FormattedMessage
                                            id="dash.stats.pages"
                                            defaultMessage="Total Info Pages"
                                        />
                                    </h4>
                                </li>

                                <li key="dash-stats-searches">
                                    <h4>
                                        <FormattedMessage
                                            id="dash.stats.searches"
                                            defaultMessage="Total Searches"
                                        />
                                        15
                                    </h4>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <div className="text-center">
                <i className="fas fa-chart-line text-light-gray my-4" style={{ fontSize: 72 }} />
                <br />
                <span className="text-muted mt-4">
                    <FormattedMessage
                        id="dash.stats.empty"
                        defaultMessage="There are no statistics to display"
                    />
                </span>
            </div>
        );
    };

    renderUpdates = () => {
        const renderMessages = (count: number) => {
            if (count > 0) {
                return (
                    <li key="dash-updates-messages" className="mr-lg-5 mr-md-4">
                        <Link className="box" to={MESSAGES_PATH}>
                            <div className="boxinner">
                                <div className="iconcol">
                                    <span>{count}</span>
                                </div>
                                <h4>
                                    <FormattedMessage
                                        id="dash.updates.msgs"
                                        defaultMessage="Messages"
                                    />
                                </h4>
                            </div>
                        </Link>
                    </li>
                );
            }
            return null;
        };

        const renderPartners = (count: number) => {
            if (count > 0) {
                return (
                    <li key="dash-updates-partners" className="mr-lg-5 mr-md-4">
                        <Link className="box" to={PARTNERS_PATH}>
                            <div className="boxinner">
                                <div className="iconcol">
                                    <span>{count}</span>
                                </div>
                                <h4>
                                    <FormattedMessage
                                        id="dash.updates.requests"
                                        defaultMessage="New Partner Requests"
                                    />
                                </h4>
                            </div>
                        </Link>
                    </li>
                );
            }
            return null;
        };

        const renderPages = (count: number) => {
            if (count > 0) {
                return (
                    <li key="dash-updates-pages" className="mr-lg-5 mr-md-4">
                        <Link className="box" to={PAGES_PATH}>
                            <div className="boxinner">
                                <div className="iconcol">
                                    <span>{count}</span>
                                </div>
                                <h4>
                                    <FormattedMessage
                                        id="dash.updates.pages"
                                        defaultMessage="New Information Pages"
                                    />
                                </h4>
                            </div>
                        </Link>
                    </li>
                );
            }
            return null;
        };
        if (
            this.props.alerts &&
            (this.props.alerts.messages > 0 ||
                this.props.alerts.partners > 0 ||
                this.props.alerts.info > 0)
        ) {
            return (
                <ul className="clearfix">
                    {renderMessages(this.props.alerts.messages)}
                    {renderPartners(this.props.alerts.partners)}
                    {renderPages(this.props.alerts.info)}
                </ul>
            );
        }
        return (
            <div className="text-center">
                <i className="fas fa-inbox text-light-gray my-4" style={{ fontSize: 72 }} />
                <br />
                <span className="text-muted">
                    <FormattedMessage
                        id="dash.updates.empty"
                        defaultMessage="There are no new updates"
                    />
                </span>
            </div>
        );
    };

    renderDatabaseItem = (database: IDatabaseBase) => {
        return (
            <tr className="trcontent" key={`dbitem-${database.name}`}>
                <td>
                    {this.isClient() ? (
                    <Link to={`${DATABASE_UPDATE_PATH(database.name)}/review`}>
                        {database.title}
                    </Link>
                    ) : (
                        <>
                        {database.title}
                        </>
                    )}
                </td>
                {this.isClient() && (
                    <td className="text-center">
                        <Link
                            className="btn icon-btn"
                            to={`${DATABASE_UPDATE_PATH(database.name)}/review`}>
                            <i className="fas fa-edit" />
                        </Link>
                    </td>
                )}
                <td className="text-center">
                    <Link
                        className="btn icon-btn"
                        to={`${SEARCH_PATH(
                            database.name,
                            (this.props.accountDetails || { name: '' }).name
                        )}`}
                        target="_blank">
                        <i className="fas fa-search" />
                    </Link>
                </td>
            </tr>
        );
    };

    renderProfileAvatar = () => {
        const imgStyle = {
            maxWidth: 250,
            minWidth: 200,
            boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
        };
        if (this.props.avatar && this.props.avatar.url) {
            return <img src={this.props.avatar.url} style={imgStyle} />;
        } else {
            imgStyle.maxWidth = 200;
            return (
                <React.Fragment>
                    <img src={defaultAvatar} style={imgStyle} />
                    <small>
                        <Link to={PROFILE_EDIT}>
                            <FormattedMessage
                                id="dash.org.avatar.edit.link"
                                defaultMessage="Edit your profile to add a logo or image"
                            />
                        </Link>
                    </small>
                </React.Fragment>
            );
        }
    };

    renderOrganization = () => {
        if (this.props.organization) {
            const organization: IOrganization = this.props.organization!;
            return (
                <div className="right-panel">
                    <div className="rightinner">
                        <div className="rightathor">
                            <div className="profileimg">{this.renderProfileAvatar()}</div>
                            <h1>{organization.orgName}</h1>
                        </div>
                        <div className="profileInfo">
                            <div className="inforow">
                                <h3>
                                    <FormattedMessage
                                        id="dash.org.website"
                                        defaultMessage="Website"
                                    />
                                    <a
                                        href={`${organization.website.indexOf('http') === -1
                                                ? 'https://'
                                                : ''
                                            }${organization.website}`}>
                                        {organization.website}
                                    </a>
                                </h3>
                            </div>
                            <div className="inforow">
                                <h3>
                                    <FormattedMessage
                                        id="dash.org.phone"
                                        defaultMessage="Main Phone"
                                    />
                                    {organization.phone}
                                </h3>
                            </div>
                            <div className="inforow">
                                <h3>
                                    <FormattedMessage
                                        id="dash.org.email"
                                        defaultMessage="Main Email"
                                    />
                                    {organization.email}
                                </h3>
                            </div>
                            <div className="inforow">
                                <h3>
                                    <FormattedMessage
                                        id="dash.org.addr"
                                        defaultMessage="Main Address"
                                    />
                                    {organization.address.firstLine}
                                    <br />
                                    {organization.address.secondLine ? (
                                        <React.Fragment>
                                            {organization.address.secondLine}
                                            <br />
                                        </React.Fragment>
                                    ) : null}
                                    {organization.address.city}
                                    <br />
                                    {organization.address.state} {organization.address.zipCode}
                                </h3>
                            </div>
                        </div>
                        <ul>
                            <li>
                                <Link to={PROFILE_EDIT}>
                                    <FormattedMessage
                                        id="dash.org.manage.link"
                                        defaultMessage="Manage Account Profile"
                                    />
                                </Link>
                            </li>
                            {/* <li>
                                <a href="#"><FormattedMessage id="dash.org.admin.link" defaultMessage="Manage Administrators" /></a>
                            </li> */}
                        </ul>
                    </div>
                </div>
            );
        }
        return null;
    };

    renderEmptyDatabaseState = () => {
        if (this.props.accountDetails && this.props.accountDetails.subscriptionLevel > 0) {
            return (
                <React.Fragment>
                    <div className="text-muted mb-5">
                        <FormattedMessage
                            id="dash.db.table.empty"
                            defaultMessage="You have not set up a database yet."
                        />
                    </div>
                    <Link to={`${DATABASE_CREATE_PATH}/general`} className="primary py-2 px-4">
                        <FormattedMessage
                            id="dash.db.purchase.link"
                            defaultMessage="Add New Database"
                        />
                    </Link>
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    <div className="text-muted mb-5">
                        <FormattedMessage
                            id="dash.db.table.nonSub"
                            defaultMessage="A subscription is required to create a database. Contact Harmonize® sales to add a subscription to your account."
                        />
                    </div>
                    <Link to={`${CONTACT_PATH}`} className="primary py-2 px-4">
                        <FormattedMessage id="dash.db.contact.link" defaultMessage="Contact Us" />
                    </Link>
                </React.Fragment>
            );
        }
    };

    renderAddDatabaseButton = () => {
        if (
            this.props.accountDetails &&
            this.props.accountDetails.subscriptionLevel > 0 &&
            this.getDatabaseCount() < this.props.accountDetails.subscriptionLevel
        ) {
            return (
                <div>
                    <Link to={`${DATABASE_CREATE_PATH}/general`} className="primary py-2 px-4">
                        <FormattedMessage
                            id="dash.db.purchase.link"
                            defaultMessage="Add New Database"
                        />
                    </Link>
                </div>
            );
        } else return null;
    };

    getDatabaseCount = () => {
        const databases = this.state.databases || [];
        if (isEmpty(databases)) {
            return 0;
        } else {
            return databases.length;
        }
    };

    renderDatabaseSection = () => {
        const { databases } = this.state;
        if (!databases) {
            return null;
        }
        if (!isEmpty(databases)) {
            return (
                <div>
                    <div className="subtitleArea">
                        <p className="text-muted font-weight-light">
                        {this.isClient() ? (    
                            <FormattedMessage
                                id="dash.db.instructions"
                                defaultMessage="The table below contains your Harmonize® databases. Click on a name to view the details of that database. Click Edit to modify the database settings. Click Delete to remove a database (Note: this action cannot be undone)."
                            />
                        ) : (
                            <FormattedMessage
                            id="dash.db.instructions"
                            defaultMessage="The table below contains a list of the Harmonize® databases you are affiliated with.  Click the appropriate Search button to search that database for resources."
                             /> 
                        )}
                        </p>
                    </div>
                    {this.renderAddDatabaseButton()}
                    <div className="admintable mt-4">
                        <table>
                            <tbody>
                                <tr className="trhead">
                                    <td>
                                        <FormattedMessage
                                            id="dash.db.table.name"
                                            defaultMessage="Database Name"
                                        />
                                    </td>
                                    {this.isClient() && (
                                        <td className="text-center">
                                            <FormattedMessage
                                                id="dash.db.table.edit"
                                                defaultMessage="Edit"
                                            />
                                        </td>
                                    )}
                                    
                                    <td className="text-center">
                                        <FormattedMessage
                                            id="dash.db.table.search"
                                            defaultMessage="Search"
                                        />
                                    </td>
                                </tr>
                                {(this.state.databases || []).map(this.renderDatabaseItem)}
                            </tbody>
                        </table>
                    </div>
                </div>
            );
        }
        return (
            <div className="text-center my-5">
                <i className="fas fa-rocket text-light-gray my-5" style={{ fontSize: 84 }} />
                <br />
                {this.renderEmptyDatabaseState()}
            </div>
        );
    };

    render() {
        return (
            <div className="row h-100">
                <div className="col-xs-12 col-lg-8 dashboard pt-5">
                    <div className="row">
                        <h2 className="col font-weight-light">
                            <FormattedMessage id="dash.updates.hdr" defaultMessage="Updates" />
                        </h2>
                        {/* TODO what is this really supposed to show? 
                        <span className="col text-right align-middle">
                            <FormattedMessage id="dash.updates.refreshed" defaultMessage="Last refreshed" />
                            <b><FormattedRelative value={Date.now()} /> <i className="fas fa-redo" /></b>
                        </span>
                        */}
                    </div>

                    <div className="col-lg-12 statisticsiconcol">{this.renderUpdates()}</div>

                    <div className="col-lg-12 martop-30">
                        <hr />
                    </div>

                    <div className="col-lg-12">
                        <h5 className="font-weight-light">
                            <FormattedMessage id="dash.db.hdr" defaultMessage="Databases" />
                        </h5>
                        {this.renderDatabaseSection()}
                    </div>

                    {/* <div className="col-lg-12 martop-30">
                        <hr />
                    </div>
                    <div className="col-lg-12">
                        <h5 className="font-weight-light"><FormattedMessage id="dash.stats.hdr" defaultMessage="Statistics" /></h5>
                        {this.renderStatistics()}
                    </div> */}
                </div>
                <div className="col pt-5">{this.renderOrganization()}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/client/dashboard/Dashboard.tsx